import React, { useContext, useEffect } from "react";
import { NavContext } from "../../state/NavContext";
import GameList from "./components/GameList";

export const Games = () => {
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("games");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  return (
    <div>
      <GameList maxItem={null} />
    </div>
  );
};

export default Games;
